import { fetchGetAttributeFailure, fetchGetAttributeSucess } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { CREATE_EDIT_GET_ATTRIBUTE_API } from "../../constants/constants";
import { attributeOptions } from "../../../Components/Pricings/Attributes/constants/InitialValues";

export const getAttributeByName = (attributeName, setLoading, setInitialValues) => (dispatch) => {
    setLoading(true)
    determineBaseUrlAndPerformApiCall(`${CREATE_EDIT_GET_ATTRIBUTE_API}/${attributeName}`, 'GET').then((response) => {
        setLoading(false)
        dispatch(fetchGetAttributeSucess(response))
        const mappedArray = response?.values?.map(value => ({
            label: value,
            value: value
        }));
        const newInitialValues = {
            name: response.name,
            type: attributeOptions.find(attr => attr.name === 'type')?.options?.find(option => option.value === response.type),
            valueType: attributeOptions.find(attr => attr.name === 'valueType')?.options?.find(option => option.value === response.valueType),
            description: response.description,
            defaultValue: response.default,
            minimumValue: response.minValue,
            maximumValue: response.maxValue,
            attributeValue: mappedArray,
            SelfcareAttribute: mappedArray,
            sequenceValue: response.sequenceValue,
            valueFormat: (response.sequenceValue !== "" )? { value: 'sequence', label: 'Sequence'} :{value: 'default', label: 'Default'},
            networkField: Array.isArray(response?.networkField) ? response?.networkField?.map(item => ({ label: item, value: item })) : response?.networkField ? [{ label: response?.networkField, value: response?.networkField }] : [],
        };
        setInitialValues(newInitialValues);
      }).catch((errorResp) => {dispatch(fetchGetAttributeFailure(errorResp.message))
        setLoading(false);
      });
};
